/**
 * Represents end of a node in serialized format.
 */
export const CLOSE_PARENS = ')';
/**
 * Represents start of a node in serialized format.
 */
export const OPEN_PARENS = '(';
